import { createLocale } from '#/localization/lib/locale-factory';

import codeSourcesLocale from './code';
import docsLocale from './docs';

export default createLocale('features', {
  ...docsLocale,
  ...codeSourcesLocale,
});
